import styled from '@emotion/styled'
import theme from '@utils/theme'

export const StyleGroupCheckboxItems = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px 20px;
`

export const StyleGroupCheckboxItem = styled.div<any>`
  display: flex;
  align-items: center;

  ${(props: any) => props.styleItem}
`

export const StyleCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
`

export const StyleCheckboxLabel = styled.p<any>`
  font-size: 15px;
  margin-left: 12px;
  color: ${(props) => props.theme.colors.text};
  line-height: 24px;
`
